import { FLXTextareaComponent } from './textarea.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [CommonModule],
	declarations: [FLXTextareaComponent],
	exports: [FLXTextareaComponent]
})
export class FLXTextareaModule {}
